import React from 'react';
import PropTypes from 'prop-types';

const SectionBannerView = ({ data }) => {
  const tone = data.tone || 'surface';
  return (
    <section className={`ag-banner ag-banner--${tone}`}>
      <div className="ag-banner__inner">
        {data.eyebrow && (
          <span className="ag-banner__eyebrow">{data.eyebrow}</span>
        )}
        <h1 className="ag-banner__title">{data.title || 'Título'}</h1>
        {data.subtitle && (
          <p className="ag-banner__subtitle">{data.subtitle}</p>
        )}
      </div>
      <div className="ag-banner__deco" aria-hidden="true">
        <svg viewBox="0 0 280 240" preserveAspectRatio="xMaxYMid slice" xmlns="http://www.w3.org/2000/svg">
          <polygon points="280,0 280,140 140,0" fill="var(--c-deco-cream)" opacity="0.85" />
          <polygon points="280,80 280,240 120,240" fill="var(--c-deco-sage)" opacity="0.75" />
          <polygon points="280,140 280,240 180,240" fill="var(--c-deco-sky)" opacity="0.8" />
          <polygon points="200,240 280,240 280,180" fill="var(--c-deco-dusty-pink)" opacity="0.7" />
        </svg>
      </div>
    </section>
  );
};

SectionBannerView.propTypes = {
  data: PropTypes.shape({
    eyebrow: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    tone: PropTypes.string,
  }).isRequired,
};
export default SectionBannerView;
